export class VariableSearchRequest {

    constructor(
        public nameFilter?: any,
        public variableIds?: number[],
        public variableTypeIds?: number[],
        public nameOrAlias?: string,
        public propertyIds?: number[],
        public methodIds?: number[],
        public scaleIds?: number[],
        public showObsoletes?: number,
        public programUUID?: string,
        public programUUIDFilter?: boolean,
        public createdDateFrom?: string,
        public createdDateTo?: string,
    ) {
    }

}
